import { LookupModelSelectionEvent } from "@mcleod/components";
import { AutogenLayoutStatusAddOrder } from "./autogen/AutogenLayoutStatusAddOrder";
import { TextboxValidator } from "@mcleod/components/src/components/textbox/TextboxValidator";
import { StringUtil } from "@mcleod/core";

export class StatusAddOrder extends AutogenLayoutStatusAddOrder {
    private _partnerId: string;
    private _orderId: string;
    private _altPartnerId: string;
    private _version: string;
    override onLoad() {
        if (!StringUtil.isEmptyString(this.orderId)) {
            this.textboxOrderNumber.addBeforeLookupModelSearchListener(event => {
                event.filter.search_order_id = this.orderId;
            })
        }
        this.textboxOrderNumber.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (event.hasSelection()) {
                if (TextboxValidator.validate(this.textboxOrderNumber, true, false).isValid) {
                    this.partnerId = event.selection.get("edi_customer.partner_id");
                    this.altPartnerId = event.selection.get("edi_customer.alt_partner_id");
                    this.version = event.selection.get("edi_customer.version");
                    this.textboxOrderNumber.validationWarning = "";
                }
            }
        });
    }

    public get partnerId(): string {
        return this._partnerId;
    }

    public set partnerId(value: string) {
        this._partnerId = value;
    }

    public get orderId(): string {
        return this._orderId;
    }

    public set orderId(value: string) {
        this._orderId = value;
    }

    public get altPartnerId(): string {
        return this._altPartnerId;
    }

    public set altPartnerId(value: string) {
        this._altPartnerId = value;
    }

    public get version(): string {
        return this._version;
    }

    public set version(value: string) {
        this._version = value;
    }

}